<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()" [label]="''"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('seatPerPassenger','title') | ibeadmin:'sync' }}</h2>
			<!-- START UNCONFIRMED ANCILLARIES WARNING /-->
			<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getSeatWarnings(flightIdentifier)">
				<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'"
					[classes]="'alert-sidebar top-gap bottom-gap'"
					[title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
				 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
					<div message><span
							*ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
						<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank"
						 aria-label="Go to refunds page">
							{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
						</a>
						{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
					</div>
				</app-notification>
			</ng-container>
			<!-- END UNCONFIRMED ANCILLARIES WARNING -->
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text ">
				<div *ngFor="let segment of segments;let i = index" class="grid no-padding">
					<!-- *ngIf="INDRA_getSeatsForPassenger(paxFareInfoFeatures, passenger.idPax)" -->
					<p class="col-4 col-tp-4 col-p-12">
						<span *ngIf="i == 0" class="bold">{{INDRA_printPassengerName(passenger)}}</span>
					</p>
					<!-- <div class=""> -->
					<p *ngIf="INDRA_populateSeatPerSegment(passenger.idPax,segment) && INDRA_populateSeatPerSegment(passenger.idPax,segment).length > 0"
						class="col-8 col-tp-8 col-p-12">
						<!-- <app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg> -->
						<!-- START UNCONFIRMED ANCILLARIES WARNING -->
						<ng-container *ngIf="INDRA_isSeatSegmentConfirmed(passenger.idPax,segment)">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
						</ng-container>
						<ng-container *ngIf="!INDRA_isSeatSegmentConfirmed(passenger.idPax,segment)">
							<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
						</ng-container>
						<!-- END UNCONFIRMED ANCILLARIES WARNING -->
						<span class="bold">{{INDRA_populateSeatPerSegment(passenger.idPax,segment)}}</span>
						<span> {{ INDRA_getTranslationKey('autoAssignedSeat','text') | ibeadmin:'sync' }}</span>
						<span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(segment)}}</span>
					</p>
					<p *ngIf="!INDRA_populateSeatPerSegment(passenger.idPax,segment)" class="col-8 col-tp-8 col-p-12">
						{{ INDRA_getTranslationKey('notChosen','text') | ibeadmin:'sync' }}
						<a href="">{{ INDRA_getSeatAreaTypeByType() | ibeadmin:'sync' }}</a>
						{{INDRA_getTranslationKey('randomlyAssignedAtCheckin','text') | ibeadmin:'sync'}}
						<span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(segment)}}</span>
					</p>
				</div>
			</div>
			<ng-container *ngIf="hasTAPOperatedFlight">
				<div class="sidebar-flight-text" *ngIf="!isMYB">
					<p>
						{{ 'whatsIncludedSidebars.detailsSeat.texts.milesAndGoInfo' | ibeadmin: 'sync' }}
					</p>
				</div>
				<div class="sidebar-flight-text" *ngFor="let ancInfo of seatTypesToShow">
					<h2 class="title-h2">{{ INDRA_getTitleForType(ancInfo) | ibeadmin:'sync' }}</h2>
					<div class="grid no-padding">
						<div *ngIf="INDRA_showSeatPhotosByType(ancInfo)" class="col-4 col-tp-4 col-p-12 no-padding bg-gallery"
							(click)="INDRA_openSlideshowByType(ancInfo)"
							style="cursor: pointer; background: url(./assets/images/ancillaries/includes/seats-reservation.jpg) no-repeat center center; background-size: cover;">
							<div class="bg-dark"></div>
							<app-svg class="list--gallery" svg="icons.svg#interface--gallery" aria-hidden="true"></app-svg>
						</div>
						<div class="col-8 col-tp-8 col-p-12">
							<p class="muted">{{ INDRA_getSeatsDescriptionForType(ancInfo) | ibeadmin:'sync' }}</p>
							<a (click)="INDRA_gotoURL('externalURLs.aboutSeatsAndEatingAreas')" href="javascript:;"
								class="link extras-feature__link link--external"
								[attr.aria-label]="INDRA_getTranslationKey('openDialogAboutSeats','aria') | ibeadmin:'sync'">{{
								INDRA_getTranslationKey('allAboutSeats','text') | ibeadmin:'sync' }}</a>
						</div>
					</div>
				</div>
			</ng-container>
			<div class="sidebar-flight-text border" *ngIf="!isBookingView && !isReviewTTTCompletion && _hasEdit">
				<p class="muted">{{ INDRA_getTranslationKey('ifSeatNotChosen','text') | ibeadmin:'sync' }}</p>
				<button class="button"
					[attr.aria-label]="INDRA_getTranslationKey('openDialogSelectSeats','aria') | ibeadmin:'sync'"
					(click)="moveToSeatsSidebar()">{{ INDRA_getTranslationKey('selectSeats','button') | ibeadmin:'sync'}}</button>
			</div>
			<div class="sidebar-flight-text" *ngIf="!isBookingView && INDRA_showUpgrade()">
				<p class="muted">{{ INDRA_getTranslationKey('upgrade','text') | ibeadmin:'sync' }}</p>
				<button class="button " (click)="INDRA_upgradeWithCash()"
					[attr.aria-label]="INDRA_getTranslationKey('openDialogUpgrade','aria') | ibeadmin:'sync'">{{
					INDRA_getTranslationKey('upgrade','button') | ibeadmin:'sync' }}
				</button>
			</div>
			<div class="sidebar-flight-text border">
				<p>
					<a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
						{{ 'whatsIncludedSidebars.detailsSeat.texts.closeWindow' | ibeadmin: 'sync' }}
					</a>
				</p>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
